import type {
  PushKeyResponse,
  PushStatusResponse,
  PushSubscriptionInput,
  PushTestResponse,
} from '@nargus/shared';
import { request } from '../http';

export const pushResource = {
  key: (): Promise<PushKeyResponse> => request('/push/key'),

  status: (): Promise<PushStatusResponse> => request('/push/status'),

  subscribe: (input: PushSubscriptionInput): Promise<void> =>
    request('/push/subscriptions', { method: 'POST', body: JSON.stringify(input) }),

  unsubscribe: (endpoint: string): Promise<void> =>
    request('/push/subscriptions', {
      method: 'DELETE',
      body: JSON.stringify({ endpoint }),
    }),

  test: (): Promise<PushTestResponse> => request('/push/test', { method: 'POST' }),
};
